import type { ShipperProfileView } from '@khaddi/contracts';
import { createContext, useContext, type ReactNode } from 'react';

type ProfileValue = {
  profile: ShipperProfileView;
  /** Re-reads /shipper/me, e.g. after toggling online or delivering (COD changes). */
  reload: () => Promise<void>;
};

const ProfileContext = createContext<ProfileValue | null>(null);

export const ProfileProvider = ({ value, children }: { value: ProfileValue; children: ReactNode }) => (
  <ProfileContext.Provider value={value}>{children}</ProfileContext.Provider>
);

export const useProfile = (): ProfileValue => {
  const value = useContext(ProfileContext);
  if (!value) throw new Error('useProfile must be used inside <ProfileProvider>');
  return value;
};
